<script setup lang="ts">
import {apiClient} from "@/api/http.ts";
import {onMounted, ref, watch} from "vue";

const props = defineProps({
  entityId: {
    required: true,
    type: Number,
  }
})
type InvoiceLine = {
  id: number
  title: string
  omschrijving?: string,
  subregel?: string,
  aantal?: number,
  prijsperproduct?: number,
  korting?: number,
  totaalprijs?: number,
  btwcode?: string
}
const invoiceLines = ref<InvoiceLine[]>([])
const loadInvoiceLines = async () => {
  if (props.entityId) {
    apiClient.get('wiser/factuurregel?page=1&perPage=25&filters='+encodeURIComponent('inverse-factuurregelsonderfactuur='+props.entityId)).then((res) => {
      invoiceLines.value = res.data
    })
  }
}
onMounted(() => {
  loadInvoiceLines()
})
watch(
  () => props.entityId,
  loadInvoiceLines
)
</script>

<template>
  <div class="model-list--InvoiceLine wiser-detail__description invoiceLines-detail__description" v-if="invoiceLines.length ?? 0 > 0">
    <h3>Factuurregels</h3>
    <ul class="model-list__items model-list-invoiceLine">
      <li class="model-list model-list-item">
        <strong>Omschrijving</strong>
        <strong>Aantal</strong>
        <strong>Stukprijs</strong>
        <strong>Korting</strong>
        <strong>Totaal</strong>
        <strong>BTW</strong>
      </li>
      <li v-for="(invoiceLine, index) in invoiceLines" :key="index" class="model-list model-list-item">
        <span>{{ invoiceLine.omschrijving }} {{ invoiceLine.subregel }}</span>
        <span>{{ Intl.NumberFormat('nl-NL').format(invoiceLine.aantal ?? 0) }}</span>
        <span>{{ Intl.NumberFormat('nl-NL', { style: "currency", currency: "EUR" }).format(invoiceLine.prijsperproduct ?? 0) }}</span>
        <span>{{ Intl.NumberFormat('nl-NL').format(invoiceLine.korting ?? 0) }}%</span>
        <span>{{ Intl.NumberFormat('nl-NL', { style: "currency", currency: "EUR" }).format(invoiceLine.totaalprijs ?? 0) }}</span>
        <span>{{ invoiceLine.btwcode }}</span>
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>
